import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {InputStatus} from '../models/input-status-type';
import '@npm-bbta/bbog-dig-dt-webcomponents-lib';
import {Router} from '@angular/router';
import {SessionStorageKeysEnum} from '../models/session-storage-keys-enum';
import {BdbSessionStrgService} from '@npm-bbta/bbog-cm-auth-lib';
import {BdbTokenAuthService} from '../shared/bdb-token-auth.service';
import {ResponseFromFetch} from '../models/response-from-fetch.model';
import {GoogleTagManagerService} from '../shared/google-tag-manager.service';
import {ServiceErrorEnum} from '../enums/service-error.enum';
import {NewServiceErrorEnum} from '../enums/new-service-error.enum';
import {RedirectService} from '../shared/redirect.service';

@Component({
    selector: 'app-bdb-token',
    templateUrl: './bdb-token.component.html',
    styleUrls: ['./bdb-token.component.scss']
})
export class BdbTokenComponent implements OnInit {
    error= ServiceErrorEnum.VALIDATE_TOKEN_ERROR;
    ignoreFirstAuthMethod: boolean = true;
    inputStatus: InputStatus = 'ENABLED';
    inputPassword: string;
    isButtonDisabled = true;
    isModalOpen = false;
    tries = 0;
    @ViewChild('bdbModalToken') bdbModalToken;
    @ViewChild('toastError') bdbAtToast: ElementRef;
    @ViewChild('loader') loader: ElementRef;
    @ViewChild('input') input: ElementRef;

    constructor(
        private readonly router: Router,
        public readonly bdbSessionStorageService: BdbSessionStrgService,
        public readonly bdbTokenAuthService: BdbTokenAuthService,
        public readonly googleTagManagerService: GoogleTagManagerService,
        private readonly redirectService: RedirectService,
    ) {
    }

    ngOnInit() {
    }

    inputChanged(event: any): void {
        this.inputPassword = event.detail.value;
        this.isButtonDisabled = this.inputPassword.length !== 6;
        if (this.inputPassword.length <= 5) {
            this.inputStatus = 'ENABLED';
        }
    }

    buttonClick() {

        // TODO consumir servicio de token
        console.log('validateToken');
        this.loader.nativeElement.openAlert();
        this.bdbSessionStorageService.save(SessionStorageKeysEnum.IDENTIFY_TYPE_AUTHENTICATION, '2');
        const identityType = this.bdbSessionStorageService.get(SessionStorageKeysEnum.IDENTITY_TYPE);
        const identityNumber = this.bdbSessionStorageService.get(SessionStorageKeysEnum.IDENTITY_NUMBER);
        const uuidAuthentication = this.bdbSessionStorageService.get(SessionStorageKeysEnum.UUID_AUTH);
        const customerToken = this.inputPassword;
        this.bdbTokenAuthService.validateAuthToken(identityType, identityNumber, customerToken,
            uuidAuthentication, this.ignoreFirstAuthMethod)
            .then((response: ResponseFromFetch) => {
                this.loader.nativeElement.handleCloseClick();
                const body = JSON.parse(response.body);
                const isValid = body.isValid;
                if (!isValid) {
                    console.log('Isvalid:', isValid);
                    this.tries++;
                    this.TokenErrorToast();
                    if (this.tries === 3) {
                        console.log('Tries:', this.tries);
                        this.router.navigate(['']);
                    }
                } else {
                    const accessToken = body.accessToken;
                    this.bdbSessionStorageService.save('accessToken', accessToken);
                    this.redirectService.redirectFromAuthentication();
                }
            }).catch((reason) => {
            this.loader.nativeElement.handleCloseClick();
            console.log('something awful happened :(', reason);
            this.redirectToErrorScreen(NewServiceErrorEnum.CHECKPIN_SERVICE_FAILURE);
        });
    }

    private redirectToErrorScreen(errorCode: NewServiceErrorEnum): void {
        this.bdbSessionStorageService.save(SessionStorageKeysEnum.ERROR_CODE, errorCode);
        this.router.navigate(['error']);
    }

    backButtonClicked($event: any) {
        this.router.navigate(['second-factor-selector']);
    }

    closeButtonCLicked($event: any) {
        this.router.navigate(['identity-number']);
    }

    showTokenModal(): void {
        this.bdbModalToken.message = 'Si eres cliente y no tienes el token actívalo en ' +
            'el app Banco de Bogotá. Descárga el app en tu celular o tablet. ';
        this.bdbModalToken.showdialog = true;
        this.isModalOpen = true;
    }

    closeTokenModal(): void {
        this.isModalOpen = false;
    }


     TokenErrorToast(): void {
        this.bdbSessionStorageService.save(SessionStorageKeysEnum.ERROR_CODE, ServiceErrorEnum.VALIDATE_TOKEN_ERROR);
        this.googleTagManagerService.sendError('Error: ' + ServiceErrorEnum.VALIDATE_TOKEN_ERROR);
        this.inputStatus = 'ERROR';
        this.bdbAtToast.nativeElement.show();
    }

}



// WEBPACK FOOTER //
// ./src/app/bdb-token/bdb-token.component.ts